import React from 'react';
import { Link } from 'react-router-dom';

import { Box, Button, Heading,Text } from '@chakra-ui/react';
import EmailInputUser from './components/EmailInputUser';
import Footer from './components/Footer';

function Support() {
  return (
    <Box display={'flex'} flexDirection='column' alignItems={'center'}>
      <Heading m={5} textAlign='center' color='white' fontSize={'4xl'}>
        Hai smarrito il tuo ordine?
      </Heading>
      <Text>Inserisci la tua mail e verranno mostrati tutti gli ordini collegati. <br/> Potrai recuperarli via mail (controlla anche nella casella spam!)</Text>
      {/* <Text>Se hai ancora problemi puoi contattare via whatsapp il numero 3470545404 </Text> */}
      <EmailInputUser/>
      {/* <Stack direction={['column']} spacing='24px'></Stack> */}
      <Button as={Link} to='/' my={50} size={'lg'}>
        Ritorna alla Home
      </Button>
      <Footer />
    </Box>
  );
}

export default Support;
